import { LicenseService } from '../../../../../app/core/license.service';
import { IdentityService } from '../../../../../app/core/authentication/services/identity.service';

export class LicenseCheckHook {

    static $inject = ["$transitions", "LicenseService", "IdentityService"];

    constructor($transitions, licenseService: LicenseService, identityService: IdentityService) {
        const isFliptoStaff = identityService.isFliptoStaff();

        $transitions.onBefore({
            to: function (state) {
                return state.data && state.data.requiredLicense;
            }
        }, function (transition) {
            const licenseRequired = transition.to().data.requiredLicense;
            const forceForFlipto = transition.to().data.forceForFlipto;
            if (licenseService.checkLicense(licenseService.getCurrentSpaceLicenses(), licenseRequired) || (forceForFlipto && isFliptoStaff)) {
                return true;
            } else {
                transition.abort();
                transition.router.stateService.go("hub", transition.params());
            }
        });

    }
}
